<scf-invest-form
  [title]="'investorForm.title'"
  [subtitle]="'investorForm.subtitle'"
  (consultEvent)="sendFormData($event)"
  [isDetailAvailable]="false"
></scf-invest-form>

<mat-card *ngIf="formData">
  <div class="panel_footer__buttons">
    <h2 fxFlex="100" translate class="margin-h2">inversorProduct.titleList</h2>
  </div>

  <div class="table__wrapper">
    <table
      aria-label="invest-product"
      mat-table
      [dataSource]="dataSrc"
      *ngIf="dataSrc.data.length > 0; else noOperations"
    >
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="first-row" translate>investorForm.months</th>
        <td mat-cell *matCellDef="let element" class="first-row bold">
          {{ element.monthYear ? (element.monthYear | uppercase) : ('investorForm.amass' | translate | uppercase) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef translate>investorForm.status</th>
        <td mat-cell *matCellDef="let element">
          <div>
            <div>
              <mat-label>{{ descriptionHeaders[0][0] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[0][1] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[0][2] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[0][3] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[0][4] | translate }}</mat-label>
            </div>
            <div class="end">
              <div>{{ element.overTotal | transformNumber }} %</div>
              <div>{{ element.numOperations | transformNumber }}</div>
              <div>{{ element.mainFunding | transformNumber }}</div>
              <div>{{ element.incentive | transformNumber }}</div>
              <div>{{ element.protections | transformNumber }}</div>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef translate>investorForm.total</th>
        <td mat-cell *matCellDef="let element; let rowIndex = index">
          <div>
            <div>
              <mat-label>{{ descriptionHeaders[1][0] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[1][1] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[1][2] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[1][3] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[1][4] | translate }}</mat-label>
              <mat-label>{{ descriptionHeaders[1][5] | translate }}</mat-label>
            </div>
            <div class="end">
              <div>{{ element.totals.numOperations | transformNumber }}</div>
              <div>{{ element.totals.totalInvest | transformNumber }}</div>
              <div>{{ element.totals.mainFunding | transformNumber }}</div>
              <div>{{ element.totals.financialSegs | transformNumber }}</div>
              <div>{{ element.totals.incentive | transformNumber }}</div>
              <div>{{ element.totals.protections | transformNumber }}</div>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['date', 'status', 'total']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['date', 'status', 'total']"></tr>
    </table>
  </div>

  <div class="panel_footer__buttons">
    <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
      <button
        id="createAllExcelPanel"
        mat-stroked-button
        color="accent"
        (click)="createExcel()"
        [disabled]="dataSrc.data.length === 0"
      >
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'request.button.excel' | translate | uppercase }}</span>
      </button>
      <button
        id="createAllPdfPanel"
        mat-stroked-button
        color="accent"
        (click)="createPdf()"
        [disabled]="dataSrc.data.length === 0"
      >
        <mat-icon class="icon-ic_print"></mat-icon>
        <span>{{ 'request.button.print' | translate | uppercase }}</span>
      </button>
    </div>
  </div>

  <ng-template #noOperations>
    <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
      <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
    </div>
  </ng-template>
</mat-card>
